import gsap from "gsap";
import {
  Object3D,
  DoubleSide,
  Mesh,
  // MeshBasicMaterial,
  PlaneGeometry,
  SphereGeometry,
  MeshStandardMaterial,
  Vector3,
  ShaderMaterial,
  RawShaderMaterial,
  AdditiveBlending,
  // BackSide,
  Color,
  Vector2,
} from "three";
import { Reflector } from "three/examples/jsm/objects/Reflector.js";
import { ScenesManager } from "../ScenesManager";
import DomeSkyShader from "../shaders/SkyDome";
import NebulaSkyShader from "../shaders/SkyNebula";
import { getParticleSystem } from "./getParticleSystem";
import FireSpark from "./FireSpark";
import { Sky } from "./Sky";
import MeshReflectorMaterial from "../materials/MeshReflectorMaterial";


export class Background extends Object3D {
  transitioning = false;
  introDone = false;
  sizes: any;
  simTween!: gsap.core.Tween;
  sphere!: Mesh;
  floor!: Mesh;
  floorMaterial!: MeshReflectorMaterial;
  nebula!: Mesh;
  nebulaUniforms: any;
  nebulaBack!: Mesh;
  nebulaLookAt!: Vector3;
  nebulaShader!: RawShaderMaterial;
  skyDomeShader!: ShaderMaterial;
  skyDome!: Mesh;
  fireflies: any;
  fireSpark!: FireSpark;
  sky!: Sky;
  constructor() {
    super();

    this.build();
  }

  build() {
    this.sizes = {
      width: window.innerWidth,
      height: window.innerHeight,
      pixelRatio: Math.min(window.devicePixelRatio, 2),
    };

    this.setObject();
  }

  setObject() {
    // Add Sky
    // this.initSkyDome();
    this.initSky();
    // this.initNebula();
    // this.initFireflies();
    // this.initFireSpark();

    const planeGeometry = new PlaneGeometry(200, 200);
    // this.floorMaterial = new MeshStandardMaterial({
    //   map: ScenesManager.assets.floorDiffuseMap,
    //   normalMap: ScenesManager.assets.floorNormalMap,
    //   displacementMap: ScenesManager.assets.floorDiffuseMap,
    //   aoMap: ScenesManager.assets.floorAoMap,
    //   roughnessMap: ScenesManager.assets.floorRoughnessMetalnessMap,
    //   metalnessMap: ScenesManager.assets.floorRoughnessMetalnessMap,
    //   alphaMap: ScenesManager.assets.floorAlphaMap,
    //   transparent: true,
    // });
   

    this.floor = new Mesh(planeGeometry);
    this.floor.rotateX(-Math.PI / 2);
    this.floor.position.set(0, -0.848, 0);
    this.floor.renderOrder = 2;
    this.floor.receiveShadow = true;
    this.add(this.floor);

    const renderer = ScenesManager.mainScene.renderer;
    const camera = ScenesManager.mainScene.camera;
    const scene = ScenesManager.mainScene.scene;

    this.floorMaterial = new MeshReflectorMaterial(renderer, camera, scene, this.floor, {
      resolution: 1024,
      blur: [512, 128],
      mixBlur: 3,
      mixStrength: 40,
      depthScale: 1.3,
      distortion: 0,
      minDepthThreshold: 1.,
      maxDepthThreshold: 1.6,
      // mirror: 1
  });

  this.floorMaterial.setValues({
    //color: new Color(0x484848),
    map: ScenesManager.assets.floorDiffuseMap,
    normalMap: ScenesManager.assets.floorNormalMap,
    normalScale: new Vector2(0.5, 0.5), 
    // displacementMap: ScenesManager.assets.floorDiffuseMap,
    // aoMap: ScenesManager.assets.floorAoMap,
    roughnessMap: ScenesManager.assets.floorRoughnessMap,
    metalnessMap: ScenesManager.assets.floorMetalnessMap,
    alphaMap: ScenesManager.assets.floorAlphaMap,
    transparent: true,
  });

  this.floor.material = this.floorMaterial;

    // const floorBlackMat = new MeshStandardMaterial({
    //   color: 0x000000,
    //   opacity: 0.99,
    //   transparent: true,
    //   side: DoubleSide,
    // });
    // const floorBlack = new Mesh(planeGeometry, floorBlackMat);
    // floorBlack.rotateX(-Math.PI / 2);
    // floorBlack.position.set(0, -1, 0);
    // floorBlack.renderOrder = 2;
    // this.add(floorBlack);

    // const floorMirror = new Reflector(planeGeometry, {
    //   clipBias: 0.003,
    //   textureWidth: window.innerWidth * window.devicePixelRatio,
    //   textureHeight: window.innerHeight * window.devicePixelRatio,
    //   color: 0x000000,
    // });
    // floorMirror.position.y = -0.92;
    // floorMirror.rotateX(-Math.PI / 2);
    // this.add(floorMirror);
  }

  initSkyDome() {
    const skyDomeRadius = 100;
    const skyDomeUniforms = {
      skyRadius: { value: skyDomeRadius },
      env_c1: { value: new Color("#181617") },
      env_c2: { value: new Color("#440300") },
      noiseOffset: { value: new Vector3(skyDomeRadius, skyDomeRadius, skyDomeRadius) },
      starSize: { value: 0.005 },
      starDensity: { value: 0.045 },
      clusterStrength: { value: 0.2 },
      clusterSize: { value: 0.2 },
      time: { value: 0 },
    };
    this.skyDomeShader = new ShaderMaterial({
      uniforms: skyDomeUniforms,
      vertexShader: DomeSkyShader.vertexShader,
      fragmentShader: DomeSkyShader.fragmentShader,
      side: DoubleSide,
      transparent: true,
    });
    const sphereGeometry = new SphereGeometry(skyDomeRadius, 32, 32);
    this.skyDome = new Mesh(sphereGeometry, this.skyDomeShader);
    this.skyDome.rotation.y = Math.PI;
    this.add(this.skyDome);
  }

  initNebula() {
    const geometry = new SphereGeometry(98, 32, 32);
    this.nebulaLookAt = new Vector3();

    this.nebulaUniforms = {
      time: {
        value: 0.0,
      },
      texture: {
        value: ScenesManager.assets.backgroundBase,
      },
      flowMap: {
        value: ScenesManager.assets.backgroundNoise,
      },
      flowStrength: {
        value: 0.191,
      },
      cycleDuration: {
        value: 4.38,
      },
      offsetTex: {
        value: new Vector3(),
      },
      alphaMultiplier: {
        value: 0.163,
      },
    };

    this.nebulaShader = new RawShaderMaterial({
      uniforms: this.nebulaUniforms,
      vertexShader: NebulaSkyShader.vertexShader,
      fragmentShader: NebulaSkyShader.fragmentShader,
      blending: AdditiveBlending,
      depthTest: true,
      depthWrite: false,
      transparent: true,
      side: DoubleSide,
    });

    this.nebula = new Mesh(geometry, this.nebulaShader);
    this.nebula.rotateY(Math.PI / 2);
    // this.add(this.nebula);

    this.nebulaBack = this.nebula.clone();
    this.nebulaBack.rotateY(Math.PI);
    // this.add(this.nebulaBack);
  }

  initSky() {
    this.sky = new Sky();
    this.sky.rotation.y = Math.PI;
    this.sky.scale.set(10, 10, 10);
    this.add(this.sky);
  }

  initFireflies() {
    this.fireflies = getParticleSystem({
      pivot: new Vector3(0, -4, 0),
      parent: this,
      rate: 30.0,
      texture: ScenesManager.assets.fireflyParticle,
    });
  }
  initFireSpark() {
    this.fireSpark = new FireSpark();
    this.add(this.fireSpark);
  }

  show() {
    return new Promise((resolve) => {
      this.transitioning = true;
      // this.skyDome.scale.set(1, 1, 1);

      this.simTween?.kill();
      this.floor.scale.set(1, 1, 1);
      this.simTween = gsap.to(this.floorMaterial, {
        opacity: 0,
        duration: 0.6,
        ease: "power0.inOut",
        onComplete: () => {
          this.introDone = true;
          resolve(true);
        },
      });

      // gsap.to(this.nebulaUniforms.alphaMultiplier, {
      //   value: 0.163,
      //   duration: 1,
      // });
      gsap.to(this.floorMaterial, {
        opacity: 1,
        duration: 1,
      });
    });
  }

  hide() {
    return new Promise(async (resolve) => {
      gsap.to(this.floorMaterial, {
        opacity: 0,
        duration: 1,
      });
      // // gsap.to(this.nebulaUniforms.alphaMultiplier, {
      // //   value: 0,
      // //   duration: 1,
      // // });
      // // this.skyDome.scale.set(0, 0, 0);
      // // this.simTween?.kill();
      // // this.simTween = gsap.to(this.skyDome.scale, {
      // //   x: 0,
      // //   y: 0,
      // //   z: 0,
      // //   duration: 1,
      // //   onComplete: () => {
      //     this.introDone = false;
      //     this.transitioning = false;
      //     resolve(true);
      //   },
      // });
          this.introDone = false;
          this.transitioning = false;
          resolve(true);
    });
  }

  hideForInterior() {
    this.floor.scale.set(0, 0, 0);
  }

  animate() {
    if (this.nebulaShader) {
      this.nebula.rotation.y -= 0.005;
      this.nebulaBack.rotation.y -= 0.005;
      this.nebulaShader.uniforms.offsetTex.value.x += 0.0005;
      this.nebulaShader.uniforms.offsetTex.value.y -= 0.001;
      this.nebulaShader.uniforms.time.value += 0.0023;
    }
    if (this.skyDome) {
      this.skyDome.rotation.y -= 0.0001;
    }

    if (this.fireflies) {
      this.fireflies.update(0.006);
    }

    if (this.floorMaterial) {
      this.floorMaterial.update();
    }

    if (this.fireSpark) {
      this.fireSpark.update(ScenesManager.clock.getElapsedTime());
    }

    if (this.sky) {
      this.sky.update(ScenesManager.clock.getElapsedTime());
    }
  }
}
